import React from 'react'
import { Paper, Theme, useMediaQuery, useTheme } from '@mui/material'

import { useSelector } from 'react-redux'
import { getGeography } from '../../../store/settings/settings.selectors'
import Niederstaucha from '../../../screens/App/Dashboard/SubScreens/Niederstaucha'
import Leipzig from '../../../screens/App/Dashboard/SubScreens/Leipzig'

const Geography: React.FC = () => {
  const theme: Theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const geography: string | undefined = useSelector(getGeography)
  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      {geography === 'niederstaucha' &&
        <Niederstaucha />}
      {geography === 'leipzig' &&
        <Leipzig />}
    </Paper>
  )
}

export default Geography
